import { Link } from 'react-router-dom';

import { useI18n } from './i18n';
import './NotFoundPage.css';

export default function NotFoundPage() {
  const { t } = useI18n();

  return (
    <div className="not-found-page">
      <section className="not-found-page__panel">
        <p className="not-found-page__code">404</p>
        <h1 className="not-found-page__title">{t.notFound.title}</h1>
        <p className="not-found-page__text">{t.notFound.text}</p>
        <div className="not-found-page__actions">
          <Link to="/" className="not-found-page__button">
            {t.nav.home}
          </Link>
          <Link to="/exam" className="not-found-page__button not-found-page__button--secondary">
            {t.nav.exam}
          </Link>
        </div>
      </section>
    </div>
  );
}
